import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiMail } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="bg-white shadow-lg fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://app1.sharemyimage.com/2025/05/19/burbank-insurance-services-in-california-logo.png" 
              alt="Burbank Insurance Services" 
              className="h-14 w-14" 
            />
            <div>
              <h1 className="text-lg font-bold text-secondary-900">Burbank Insurance Services</h1>
              <p className="text-xs text-secondary-600">CA License #6013543</p>
            </div>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <Link 
              to="/term-life-insurance" 
              className="text-secondary-700 hover:text-primary-600 font-medium"
            >
              Term Life
            </Link>
            <Link 
              to="/whole-life-insurance" 
              className="text-secondary-700 hover:text-primary-600 font-medium"
            >
              Whole Life
            </Link>
            <Link 
              to="/indexed-universal-life-insurance" 
              className="text-secondary-700 hover:text-primary-600 font-medium"
            >
              IUL
            </Link>
            <Link 
              to="/no-medical-exam-insurance" 
              className="text-secondary-700 hover:text-primary-600 font-medium"
            >
              No Medical Exam
            </Link>
            <Link 
              to="/final-expense-insurance" 
              className="text-secondary-700 hover:text-primary-600 font-medium"
            >
              Final Expense
            </Link>
            <div className="flex items-center space-x-4 text-sm">
              <a
                href="https://quote.burbankinsuranceservices.com/Dt2tCn"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-1 text-secondary-600 hover:text-primary-600"
              >
                <SafeIcon icon={FiMail} className="h-4 w-4" />
                <span>Get Quote</span>
              </a>
            </div>
          </nav>

          <button 
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-md text-secondary-700 hover:bg-secondary-100"
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="h-6 w-6" />
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-secondary-200">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/term-life-insurance" 
                className="text-secondary-700 hover:text-primary-600 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Term Life Insurance
              </Link>
              <Link 
                to="/whole-life-insurance" 
                className="text-secondary-700 hover:text-primary-600 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Whole Life Insurance
              </Link>
              <Link 
                to="/indexed-universal-life-insurance" 
                className="text-secondary-700 hover:text-primary-600 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Indexed Universal Life
              </Link>
              <Link 
                to="/no-medical-exam-insurance" 
                className="text-secondary-700 hover:text-primary-600 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                No Medical Exam
              </Link>
              <Link 
                to="/final-expense-insurance" 
                className="text-secondary-700 hover:text-primary-600 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Final Expense Insurance
              </Link>
              <div className="pt-4 border-t border-secondary-200">
                <a
                  href="https://quote.burbankinsuranceservices.com/Dt2tCn"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-secondary-600"
                >
                  <SafeIcon icon={FiMail} className="h-4 w-4" />
                  <span>Get Quote</span>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;